import { useMutation } from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_FILE_STORAGE } from "../domain";

import { fileApi } from "@api/services";
import { roleGuard } from "@api";
import { triggerDownloadFile } from "@helpers";

export const ACTION_DOWNLOAD_FILE = "DOWNLOAD_FILE";

const allowedRoles = [UserRole.Owner, UserRole.Manager, UserRole.Respondent, UserRole.Auditor];

interface DownloadFileRequest {
  path: string;
  name: string;
}

const downloadFile = async ({ path, name }: DownloadFileRequest): Promise<void> => {
  const response = await fileApi.fileStorageControllerDownloadFile(path, {
    responseType: "blob",
  });

  return triggerDownloadFile(response.data, name);
};

export const useDownloadFile = (
  user: UserProfileDto | null,
): {
  downloadFile: ({ path, name }: DownloadFileRequest) => Promise<void>;
  downloadFileEnabled: boolean;
  isSuccessDownloadFile: boolean;
  isPendingDownloadFile: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { mutateAsync, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_FILE_STORAGE, ACTION_DOWNLOAD_FILE],
    mutationFn: downloadFile,
  });

  return {
    downloadFile: mutateAsync,
    downloadFileEnabled: enabled,
    isSuccessDownloadFile: isSuccess,
    isPendingDownloadFile: isPending,
  };
};
